import { render, staticRenderFns } from "./InvoiceNumberCell.vue?vue&type=template&id=3b0bae6d&"
import script from "./InvoiceNumberCell.vue?vue&type=script&lang=js&"
export * from "./InvoiceNumberCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports